import { render } from "./PatientTransferButton.vue?vue&type=template&id=59f602d6"
import script from "./PatientTransferButton.vue?vue&type=script&lang=js"
export * from "./PatientTransferButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__